import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import AdminNotice from '../../../../components/AdminNotice';
import Cell from '../../../../components/Cell';
import Header from '../../../../components/Table/Header';
import Table from '../../../../components/Table';
import Icon from '../../../../components/Icon';
import { I18n } from 'react-redux-i18n';

const UserListCardContainer = styled.div`
  max-width: calc(100vw - 170px) !important;

  .name {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    width: calc(20% - 30px);
    padding-left: 30px;
  }

  .userName {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    width: calc(30% - 30px);
    padding-left: 30px;
  }

  .userActive {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    justify-content: center;
    width: 10%;
  }

  .userAction {
    justify-content: center;
    width: 20%;
  }

  .zoneItemIcon {
    margin-left: 18px;
    margin-right: 31px;
    color: #00a699;
  }

  .zoneItemIconDisabled {
    margin-left: 13px;
    margin-right: 26px;
    color: #868e96;
    width: 17px;
    height: 17px;
  }

  @media (max-width: 1900px) {
  }
`;

class UserListCard extends Component {
  constructor(props) {
    super(props);
    this.state = { sorted: [] };
  }

  handleSort(id) {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted });
  }

  getColumns() {
    const { data } = this.props;
    const services = this.props.services || [];
    let columns = [
      {
        accessor: 'name',
        Header: () => (
          <Header
            sortable={true}
            sort={() => this.handleSort('name')}
            styles={`.title{font-size:12px};`}
            title={I18n.t('admin.listUserName')}
          />
        ),
        Cell: (props) => (
          <Cell
            {...props}
            font="sfcompact_text"
            styles={`justify-content:flex-start;padding-left:20px; font-size:12px; font-weight: 600`}
          >
            {props.value}
          </Cell>
        ),
        minWidth: 150,
        maxWidth: 350
      }
    ];
    services.forEach((service) => {
      if (
        data.find((user) => user.services.includes(service.name)) &&
        service.name !== 'default'
      ) {
        columns.push({
          Header: () => (
            <Header
              title={service.name}
              sort={() => this.handleSort('services')}
              styles={`.title{font-size:12px}`}
            />
          ),
          Cell: (props) => (
            <Cell
              {...props}
              value={
                <div
                  className={
                    !props.value.includes(service.name)
                      ? 'zoneItemIconDisabled'
                      : 'zoneItemIcon'
                  }
                >
                  <Icon
                    icon={
                      !props.value.includes(service.name) ? 'close' : 'check'
                    }
                  />
                </div>
              }
            />
          ),
          accessor: 'services'
        });
      }
    });
    return columns;
  }

  formatData() {
    const { data } = this.props;
    let formattedData = [...data];
    return formattedData
      .filter((item) => item.is_active)
      .map((item) => ({
        ...item,
        name: `${item.first_name} ${item.last_name}`,
        is_active: item.is_active ? I18n.t('yes') : I18n.t('no')
      }));
  }

  render() {
    const formattedData = this.formatData();
    const { sorted } = this.state;
    const columns = this.getColumns();
    return (
      <UserListCardContainer>
        <Card>
          <CardHeader
            title={I18n.t('admin.userList')}
            icon="espace"
            iconContainer
            iconPosition="left"
            textTransform="normal"
          />
          {this.props.admin && <AdminNotice />}
          <Table
            data={formattedData}
            columns={columns}
            sorted={sorted}
            subRowsKey={null}
          />
        </Card>
      </UserListCardContainer>
    );
  }
}

export default UserListCard;
